import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader
} from '../../components/other/card/card'
import CampaignDropdown from '../../components/CampaignDropdown'
import { useGetServicesQuery } from '../../redux/apis/servicesManagement/sMServicesApiSlice'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import TextArea from 'antd/es/input/TextArea'
import Loader from '../pages/loader'
import { Input } from 'antd'
import { useCreateTelegramMutation } from '../../redux/apis/linkManagement/telegram/lMTelegramApiSlice'
import InsertionResultModal from '../../components/InsertionResultModal'

const TelegramInsertion = React.memo(() => {
  const context = useContext(AppSettings)
  const [create, { isLoading }] = useCreateTelegramMutation()
  const [result, setResult] = useState(null)
  const { data: servicesData } = useGetServicesQuery({
    fields: ['id', 'service_name'],
    page: '*',
    is_active: true
  })

  const telegramServiceId = servicesData?.data?.results?.find(
    s => s.service_name?.toLowerCase() === 'telegram'
  )?.id

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      campaign: '',
      urls: '',
      channel_url: '',
      link_keyword: ''
    },

    validationSchema: Yup.object({
      urls: Yup.string().required('Please Enter Urls'),
      link_keyword: Yup.string(),
      campaign: Yup.number().required('Please Enter Campaign ')
    }),

    onSubmit: async values => {
      const urls = values.urls
        .split('\n')
        .map(url => url.trim())
        .filter(url => url)

      const data = urls.map(url => ({
        campaign: values.campaign,
        url: url,
        channel_url: values.channel_url.trim(),
        service: telegramServiceId,
        ...(values.link_keyword ? { link_keyword: values.link_keyword } : {}),
        is_related: true,
        review_date: new Date().toISOString().split('T')[0],
        crawl_date: new Date().toISOString().split('T')[0]
      }))

      try {
        const res = await create(data)
        const resultData = res?.data ?? res?.error?.data ?? {}
        setResult(resultData)
        const insertedLinks =
          resultData?.new_links ?? resultData?.inserted_links ?? 0
        if (insertedLinks > 0) {
          validation.resetForm()
        }
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div>
      <Loader isLoading={isLoading} />
      <InsertionResultModal
        result={result}
        reportTitle='Telegram URL insertion'
        onClose={() => setResult(null)}
      />
      <Card>
        <CardHeader>
          <p>Telegram Link Insertion</p>
        </CardHeader>
        <CardBody>
          {telegramServiceId ? (
            <CampaignDropdown
              onBlur={validation.handleBlur}
              onChange={e => {
                validation.setFieldValue('campaign', e)
              }}
              status="active"
              value={validation.values?.campaign}
              service_id={telegramServiceId}
              className='customSelect'
            />
          ) : (
            <div className='mb-3'>
              <label className="form-label">Campaign</label>
              <br />
              <div className='customSelect' style={{ height: 38, background: '#f5f5f5', borderRadius: 6 }} />
            </div>
          )}
          {validation.touched.campaign && validation.errors.campaign ? (
            <p className='text-danger'>{validation.errors.campaign}</p>
          ) : null}
          <div className=' mb-3 customInput'>
            <label className="form-label">Channel URL</label>
            <Input
              type='text'
              name='channel_url'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.channel_url}
              placeholder='Enter channel URL (optional)'
            />
          </div>
          <div className=' mb-3 customInput'>
            <label className="form-label">Keyword</label>
            <Input
              type='text'
              name='link_keyword'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.link_keyword}
              placeholder='Enter keyword (optional)'
            />
          </div>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">URLs (separated by new lines)</label>
            <TextArea
              type='text'
              name='urls'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.urls}
              placeholder='Enter urls separated by new lines
              example:
              test.com
              test2.com
              test3.com
              '
              rows={15}
            />
            {validation.touched.urls && validation.errors.urls ? (
              <p className='text-danger'>{validation.errors.urls}</p>
            ) : null}
          </div>
        </CardBody>
        <CardFooter>
          <div className='flex justify-end gap-8'>
            <button
              onClick={() => {
                validation.handleSubmit()
              }}
              className='btn btn-theme'
            >
              Submit
            </button>
          </div>
        </CardFooter>
      </Card>
    </div>
  )
})

export default TelegramInsertion
